import React, { useEffect, useState, Fragment } from 'react';
import { Container, Grid, makeStyles, Hidden, Fab } from '@material-ui/core';
import {
  Idea,
  FeedIdentity,
  Contents,
  Ranking,
  Copyright,
  IdeaCreateBoxFeed,
  IdeaPoints,
  DialogAllCreateIdea,
  ChallengeBanner,
} from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import {
  timelineActions,
  userActions,
  ideaCreateDialogsActions,
} from '../../actions';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useLastLocation } from 'react-router-last-location';
import { Loading, FilterTimeline } from '../../components';
import { HighlightCard, SkeletonCardsHome } from './../../components';
import { ModalWelcome } from '../../components/ModalWelcome/ModalWelcome';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
  containerLoading: {
    display: 'flex',
    justifyContent: 'center',
  },
  fixed: {
    position: 'sticky',
    boxSizing: 'border-box',
    height: 'calc(100vh - 70px)',
    top: '70px',
  },
  fab: {
    position: 'fixed',
    zIndex: 1200,
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function HomePage() {
  const [welcomePopUp, setWelcomePopUp] = useState(false);
  const [lastLocation] = useState(useLastLocation());
  const classes = useStyles();
  const dispatch = useDispatch();
  const ideas = useSelector((state) => state.timeline.ideas);
  const { page, sort, search, hasNextPage } = useSelector((state) => state.timeline.paging);
  const loading = useSelector((state) => state.timeline.loading);
  const challenges = useSelector((state) => state.timeline.challenges);

  const { loadingUpIdea, loadingUpComment } = useSelector(
    (state) => state.timeline
  );
  const { details, _id } = useSelector((state) => state.user);

  function loadMoreIdeas() {
    if (!loading && hasNextPage) {
      dispatch(timelineActions.getTimeline(page, sort, search));
    }
  }

  useEffect(() => {
    dispatch(userActions.getUserDetailsRaking());
    dispatch(timelineActions.getBannersChallenge());

    return () => dispatch(timelineActions.clearAll());
  }, [dispatch]);

  useEffect(() => {
    dispatch(timelineActions.getTimeline(1, { timelineDate: -1 }, search));
  }, [dispatch, search]);

  useEffect(() => {
    if (lastLocation?.pathname === '/register') {
      setWelcomePopUp(true)
    }
  }, [lastLocation])

  return (
    <Container maxWidth="lg" className={classes.root}>
      <ModalWelcome
        openWelcomePopUp={welcomePopUp}
      />
      <DialogAllCreateIdea />
      <Grid container spacing={3}>
        <Hidden xsDown>
          <Grid item xs={4} md={3}>
            <FeedIdentity />
            <div className={classes.fixed}>
              <IdeaPoints
                ideaTotal={details?.idea}
                walletAmmount={details?.wallet[0]?.amount}
                userId={_id}
              />
              <Ranking ranking={details?.ranking} />
              <Copyright />
            </div>
          </Grid>
        </Hidden>
        <Grid item xs={12} sm={8} md={6}>
          <Hidden smUp>
            <Fab
              aria-label="add"
              className={classes.fab}
              color="secondary"
              onClick={() =>
                dispatch(ideaCreateDialogsActions.openDialogTitleDescription())
              }
            >
              <EmojiObjectsIcon style={{ fontSize: 36 }} />
            </Fab>
          </Hidden>
          <Hidden smDown>
            <IdeaCreateBoxFeed />
          </Hidden>
          <Hidden smUp>
            {challenges?.length > 0 && (
              <ChallengeBanner challenges={challenges} />
            )}
          </Hidden>
          <FilterTimeline />
          <HighlightCard />
          <InfiniteScroll
            dataLength={ideas.length}
            next={loadMoreIdeas}
            hasMore={true}
            scrollThreshold={'90%'}
            loader={
              loading && (
                <SkeletonCardsHome />
              )
            }
          >
            {ideas.length > 0 && ideas.map((idea, index) => (
              <Idea
                index={index}
                idea={idea}
                key={idea._id}
                loadingUpIdea={loadingUpIdea}
                loadingUpComment={loadingUpComment}
              />
            ))}
          </InfiniteScroll>
        </Grid>
        <Hidden smDown>
          <Grid item xs={3} className={classes.leftFixed}>
            {challenges?.length > 0 && (
              <ChallengeBanner challenges={challenges} />
            )}
            <div className={classes.fixed}>
              <Contents title />
            </div>
          </Grid>
        </Hidden>
      </Grid>
    </Container>
  );
}

export { HomePage };
